import {useEffect} from 'react';
import {get} from 'lodash';
import {SelectGroupOption} from '../../../components/AutoForm/AutoFieldNew';
import {useRecommendContext} from './CreateRecommendHelpers';
import {recommendFieldsType} from './recommendFields';
import {useAutoForm} from '../../../components/AutoForm/useAutoForm';
import {PlanProviderSelectOption} from '../../../hooks/usePlanNamesProviders';
import {UPDATES} from '../../../shared/UPDATES';

export const getSaltusProviderValue = ({
  productProvidersOptionGroups,
  productProvidersOptions,
}: {
  productProvidersOptionGroups: SelectGroupOption[] | null;
  productProvidersOptions: PlanProviderSelectOption[] | null;
}) => {
  const saltusProviders = productProvidersOptionGroups
    ? productProvidersOptionGroups.find(
        (x) => x.groupLabel.toLocaleLowerCase() === 'favourite'
      )?.options
    : [
        productProvidersOptions?.find(
          (x) => x.isSaltus && x.group?.toLocaleLowerCase() === 'favourite'
        ),
      ];
  const provider = saltusProviders?.length ? saltusProviders?.[0]?.value : null;
  return provider;
};

export const useSPPProviders = (
  fieldId: string,
  productProvidersOptionGroups: SelectGroupOption[] | null,
  productProvidersOptions: PlanProviderSelectOption[] | null,
  isPensionWrapper: boolean,
  isSubplan: boolean
): {disableProviderField: boolean} => {
  const {setFieldValue, values} = useAutoForm<recommendFieldsType>();
  const {isSPPDA} = useRecommendContext();

  useEffect(() => {
    if (
      isSPPDA &&
      (productProvidersOptionGroups?.length || productProvidersOptions?.length) &&
      !isSubplan
    ) {
      const existingValue = get(values, fieldId);
      if (!existingValue) {
        const saltusProviderValue = getSaltusProviderValue({
          productProvidersOptionGroups,
          productProvidersOptions,
        });

        setFieldValue(UPDATES._522, fieldId, saltusProviderValue);
      }
    }
  }, [isSPPDA, productProvidersOptionGroups, productProvidersOptions, isSubplan]);

  if (
    isSPPDA &&
    (productProvidersOptionGroups?.length || productProvidersOptions?.length) &&
    !isSubplan
  ) {
    const saltusProviderValue = getSaltusProviderValue({
      productProvidersOptionGroups,
      productProvidersOptions,
    });
    if (saltusProviderValue) {
      return {disableProviderField: true};
    }
  }
  return {disableProviderField: false};
};
